import React from "react";
import { getImageUrl } from "utils/helpers";
import styled from "styled-components";
import theme from "styles/theme";

const Image = styled.img`
  max-width: 160px;
  max-height: 48px;
  ${(props) => props.src.endsWith(".svg") && `width: 100%;`}

  ${theme.media.phone`
    max-width: 96px;
    max-height: 48px;
  `}
`;

const CompanyLogo = ({ className, logoUrl, companyUrl, alt }) => {
  return (
    <a href={`https://${companyUrl}`}>
      <Image
        className={className}
        src={getImageUrl(logoUrl, "png", 300)}
        alt={alt}
      />
    </a>
  );
};

export default CompanyLogo;
